export default __webpack_public_path__ + "static/media/icon_shop.9d6f37ef.svg";